import { useCallback, useEffect, useState } from "react";
import { FaCheckCircle } from "react-icons/fa";
import { FaPen, FaPlus, FaSpinner, FaXmark } from "react-icons/fa6";
import { InputDefault } from "../../../../components/forms/InputDefault";
import { TextAreaDefault } from "../../../../components/forms/TextAreaDefault";
import { BankAccountService } from "../../../../services/BankAccountService";

export const BankAccountUpdate = ({ open, setOpen, refreshData, data }) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const [formData, setFormData] = useState({
        primary: 1,
        bank_name: "",
        account_number: "",
        account_holder_name: "",
        description: "",
    });

    useEffect(() => {
        setFormData({
            primary: data?.primary ?? 0,
            bank_name: data?.bank_name,
            account_number: data?.account_number,
            account_holder_name: data?.account_holder_name,
            description: data?.description,
        });
    }, [data]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            await BankAccountService.update({ id: data?.id, data: formData });

            setOpen(false);
            if (refreshData) refreshData();

        } catch (err) {
            // handleError(err, "Gagal menerbitkan invoice dengan pembayaran.");
        } finally {
            setLoading(false);
        }
    };

    if (!open) return null;

    const INPUT_CLS =
        "w-full px-4 py-2.5 text-sm rounded-xl bg-slate-800/60 border border-slate-600/40 text-gray-100 placeholder-slate-500 outline-none focus:border-cyan-500/50 focus:ring-1 focus:ring-cyan-500/20 transition-all";

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center p-4"
            onClick={() => setOpen(false)}
        >
            <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />
            <div
                className="relative w-full max-w-lg rounded-2xl overflow-hidden shadow-2xl"
                style={{
                    background: "rgba(15, 23, 42, 0.95)",
                    border: "1px solid rgba(51, 65, 85, 0.4)",
                }}
                onClick={(e) => e.stopPropagation()}
            >
                {/* Header */}
                <div
                    className="px-5 py-4 flex items-center justify-between"
                    style={{ borderBottom: "1px solid rgba(51, 65, 85, 0.3)" }}
                >
                    <div className="flex items-center gap-2.5">
                        <div
                            className="w-8 h-8 rounded-lg flex items-center justify-center"
                            style={{
                                background: "rgba(0, 180, 216, 0.12)",
                                border: "1px solid rgba(0, 180, 216, 0.2)",
                            }}
                        >
                            <FaPlus className="text-sm text-cyan-400" />
                        </div>
                        <div>
                            <h3 className="text-sm font-bold text-gray-100">
                                Update Rekening Bank
                            </h3>
                            <p className="text-xs text-slate-500">
                                perbarui data rekening bank
                            </p>
                        </div>
                    </div>
                    <button
                        onClick={() => setOpen(false)}
                        className="w-8 h-8 rounded-lg flex items-center justify-center text-slate-400 hover:text-gray-100 hover:bg-slate-700/50 transition-all"
                    >
                        <FaXmark className="text-sm" />
                    </button>
                </div>

                {/* Form */}
                <form onSubmit={handleSubmit}>
                    <div
                        className="p-5 space-y-4 max-h-[65vh] overflow-y-auto"
                    >
                         {/* Primary Toggle */}
                        <div className="flex items-center justify-between p-3 rounded-xl" style={{ background: "rgba(51, 65, 85, 0.15)", border: "1px solid rgba(51, 65, 85, 0.2)" }}>
                            <div>
                                <p className="text-sm font-medium text-gray-200">Primary</p>
                                <p className="text-xs text-slate-500 mt-0.5">Semua notifikasi terkait akan menggunakan akun ini</p>
                            </div>
                            <button
                                type="button"
                                onClick={() => setFormData({...formData, primary: !formData.primary})}
                                className={`relative w-11 h-6 rounded-full transition-all duration-200 flex-shrink-0 ${formData.primary ? "bg-emerald-500" : "bg-slate-600"
                                    }`}
                            >
                                <span
                                    className={`absolute top-0.5 w-5 h-5 bg-white rounded-full shadow transition-all duration-200 ${formData.primary ? "left-[22px]" : "left-0.5"
                                        }`}
                                />
                            </button>
                        </div>

                        {/* Bank Name  */}
                        <InputDefault
                            id="name"
                            label="Nama Bank"
                            placeholder="BCA, Mandiri, BRI..."
                            value={formData.bank_name}
                            onChange={(e) => setFormData({...formData, bank_name: e.target.value})}
                        />

                        {/* Account Number */}
                        <InputDefault
                            id="accountNumber"
                            label="No Rekening"
                            placeholder="masukan no rekening"
                            value={formData.account_number}
                            onChange={(e) => setFormData({...formData, account_number: e.target.value})}
                        />

                        {/* Account Holder */}
                        <InputDefault
                            id="accountHolderNumber"
                            label="Nama Pemilik Rekening"
                            placeholder="masukan nama pemilik rekening"
                            value={formData.account_holder_name}
                            onChange={(e) => setFormData({...formData, account_holder_name: e.target.value})}
                        />

                        {/* Description */}
                        <TextAreaDefault
                            id="description"
                            label="Keterangan"
                            placeholder="Rekening utama perusahaan..."
                            value={formData.description}
                            onChange={(e) => setFormData({...formData, description: e.target.value})}
                        />
                    </div>

                    {/* Footer */}
                    <div
                        className="px-5 py-4 flex gap-3"
                        style={{ borderTop: "1px solid rgba(51, 65, 85, 0.3)" }}
                    >
                        <button
                            type="button"
                            onClick={() => setOpen(false)}
                            disabled={loading}
                            className="flex-1 px-4 py-2.5 rounded-xl text-sm font-medium text-slate-300 transition-all disabled:opacity-50 hover:bg-slate-700/30"
                            style={{
                                background: "rgba(51, 65, 85, 0.3)",
                                border: "1px solid rgba(51, 65, 85, 0.3)",
                            }}
                        >
                            Batal
                        </button>
                        <button
                            type="submit"
                            disabled={loading}
                            className="flex-1 px-4 py-2.5 rounded-xl text-sm font-bold text-white bg-cyan-600 hover:bg-cyan-500 transition-all disabled:opacity-50 flex items-center justify-center gap-2 shadow-lg shadow-cyan-600/20"
                        >
                            {loading ? (
                                <>
                                    <FaSpinner className="animate-spin text-xs" /> Menyimpan...
                                </>
                            ) : (
                                <>
                                    <FaCheckCircle className="text-xs" />{" "}
                                    Simpan
                                </>
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};